import { render, staticRenderFns } from "./ResultsTableVuetify.vue?vue&type=template&id=172bf08e&scoped=true"
import script from "./ResultsTableVuetify.vue?vue&type=script&lang=js"
export * from "./ResultsTableVuetify.vue?vue&type=script&lang=js"
import style0 from "./ResultsTableVuetify.vue?vue&type=style&index=0&id=172bf08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172bf08e",
  null
  
)

export default component.exports